import { createStore } from 'redux'

// The finance pages' Live / Test switch (sidebar), remembered in this browser
const savedFinanceMode = () => {
  try {
    return localStorage.getItem('finance.mode') === 'test' ? 'test' : 'live'
  } catch (e) {
    return 'live'
  }
}

const initialState = {
  sidebarShow: true,
  financeMode: savedFinanceMode(),
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
